import { React, variantProvider, Settings } from '@/app'
import { CenterWrapperProps } from '@codeleap/web'
import { View, RouterPage, CenterWrapper, Footer, Header } from '@/components'

import { Helmet } from 'react-helmet'
import { useComponentStyle } from '@codeleap/common'
import { HeaderProps } from './Header'

type PageProps = CenterWrapperProps & {
  center?: boolean
  withRouter?: boolean
  basePath?: string
  title?: string
  header?: boolean
  footer?: boolean
  appendNameToTitle?: boolean
  className?: string
  headerProps: HeaderProps
}

export const Page: React.FC<PageProps> = (props) => {
  const {
    children,
    center = true,
    basePath,
    title,
    appendNameToTitle = true,
    header = true,
    footer = true,
    withRouter,
    className,
    headerProps,
    ...centerWrapperProps
  } = props

  const content = withRouter ? (
    <RouterPage basePath={basePath} title={title}>
      {children}
    </RouterPage>
  ) : (
    children
  )

  const styles = useComponentStyle(componentStyles)
  return (
    <View variants={['column']} css={[styles.wrapper, !center && centerWrapperProps?.styles?.wrapper]} className={className}>
      <Helmet>
        <meta property='og:site_name' content={Settings.site_name} />
        <meta name='og:site_name' content={Settings.site_name} />
        <meta name='application-name' content={Settings.application_name} />
        <meta name='description' content={Settings.Description} />

        <script type='application/ld+json'>
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            'name': Settings.site_name,
            'alternateName': [Settings.site_name, 'Cherry Dating'],
            'url': Settings.site_url,
          })}
        </script>
        {title && <title>{title} {appendNameToTitle ? ` | ${Settings.AppName}` : ''}</title>}
      </Helmet>
      {header && <Header {...headerProps} />}
      {center ? (
        <CenterWrapper {...centerWrapperProps}>{content}</CenterWrapper>
      ) : (
        content
      )}

      {footer && <Footer />}
    </View>
  )
}
const componentStyles = variantProvider.createComponentStyle((theme) => ({
  wrapper: {
    minHeight: '100vh',
    minWidth: '100%',
    maxWidth: '100%',
    backgroundColor: theme.colors.primary,
  },
}))
